export default __webpack_public_path__ + "static/media/search-icon.9ee40c87.svg";